export const hof_data = [
    {
        "pro_champs": [
            {
                "firstName": "Matt",
                "lastName": "Kelly",
                "year": 2018,
                "result": 10,
                "food": "Hot Dogs",
                "desc": "In a sea of ketchup, Kelly made Gullet Stuffer history with a stunning ten frankfurters as he breezed to the first ever Professional title.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/mattkell.png"
            },
            {
                "firstName": "Jimmy",
                "lastName": "Esteban",
                "year": 2019,
                "result": "68 (+5)",
                "food": "Pizza Rolls",
                "desc": "Five bonus pizza rolls were no match for Jimmy in an unprecedented 'Eat Off' at the conclusion of Gullet Stuffer II. His secret? Eating a head of cabbage the night before.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/Jamesteban.jpg"
            },
            {
                "firstName": "Carter",
                "lastName": "Burns",
                "year": 2021,
                "result": 74,
                "food": "oz of soup",
                "desc": "The soaring soup temperatures of GSIII had no effect on Burns, who traveled up from San Francisco to compete. His prize included a custom pair of Gullet Stuffer sneakers.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/Carter.jpg"
            },
            {
                "firstName": "Cameron",
                "lastName": "Gould",
                "year": 2022,
                "result": 56,
                "food": "Dino Nuggets",
                "desc": "After hearing about the competition through TikTok, Cameron was added to the field as a last-minute alternate. 'Mr. Impossible' proceeded to shock the parking lot with his nonstop nugget annihilation.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/CamPossible.jpg"
            },
            {
                "firstName": "Dee",
                "lastName": "Street",
                "year": 2023,
                "result": 36,
                "food": "Eggo Waffles",
                "desc": "Completely unknown going into GSV, Domenica, aka Dee Street, put down an entire bottle of syrup and a tub of butter in addition to her 36 waffles. She is now the early favorite for GSVI.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/deewinsreal.png"
            },
            {
                "firstName": "Dee",
                "lastName": "Street",
                "year": 2024,
                "result": 103,
                "food": "Mini Donuts",
                "desc": "Dee went full sicko mode in her quest for a repeat, trailing early before making a mad dash for the finish line, becoming the first Gullet Stuffer to ever win multiple Professional titles",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/deegsvi.jpg"
            },
            {
                "firstName": "Naader",
                "lastName": "Reda",
                "year": 2025,
                "result": 116,
                "food": "Gyoza",
                "desc": "Making the trip all the way from Las Vegas, 'FreakEating' watched Miles Zoltak burst out to a big lead, then methodically hawked him down in the home stretch, winning in the final moments by a single gyoza in a Gullet Stuffer instant classic.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/pro_champs/naader.jpg"
            }
        ],
        "amateur_champs": [
            {
                "firstName": "John",
                "lastName": "Akers",
                "year": 2018,
                "result": 6,
                "food": "Hot Dogs",
                "desc": "It was a photo finish, but 'The Akinator' had just enough room to become the first Amateur champion. He returned to the field in 2022 as a Professional.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/JohnAkers.jpg"
            },
            {
                "firstName": "Valerie",
                "lastName": "Yuryk",
                "year": 2019,
                "result": 57,
                "food": "Pizza Rolls",
                "desc": "Slow and steady was the recipe for Yuryk, as she blazed her way to the lower division title in front of a frenzied crowd. She made one additional appearance in Gullet Stuffer MegaBites and was immediately DQ'd.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/ValYuryk.jpg"
            },
            {
                "firstName": "Mark",
                "lastName": "Bechtel",
                "year": 2021,
                "result": 70.5,
                "food": "oz of soup",
                "desc": "A last second entrant, 'Big Soup' Bechtel was able to stomach the majority of mysterious orange broth to earn his first title. He would appear once again in 2023.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/MarkB.png"
            },
            {
                "firstName": "Julian",
                "lastName": "Saquic-Ray",
                "year": 2022,
                "result": 42,
                "food": "Dino Nuggets",
                "desc": "After pulling out of GSIII due to illness, Julian came back and reigned as King of the Amateurs. \"These hoes ain't loyal\", he declared.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/julian.png"
            },
            {
                "firstName": "Mark",
                "lastName": "Bechtel",
                "year": 2023,
                "result": 16,
                "food": "Eggo Waffles",
                "desc": "After a year layoff, this time facing a solid food, Bechtel dug deep on his way to a one waffle win. Note: Amateur Champions are no longer allowed to appear for 2nd time, aka the \"Big Soup Rule\".",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/markwins2.png"
            },
            {
                "firstName": "George",
                "lastName": "Tecero",
                "year": 2024,
                "result": 45,
                "food": "Mini Donuts",
                "desc": "After receiving some pregame advice from 2024 Nathan's Hot Dog Champ Patrick Bertoletti, George stormed the podium, much to the delight of his many fans in attendance.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/george.jpg"
            },
            {
                "firstName": "Jessamyn",
                "lastName": "Reichmann",
                "year": 2025,
                "result": 74,
                "food": "Gyoza",
                "desc": "Seattle's Sweetheart made her much anticipated Amateur debut by jumping out to a huge lead and dancing her way to the finish line while onlookers shrieked in delight.",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/amateur_champs/jessamyn.jpg"
            }
        ],
        "notable_competitors": [
            {
                "firstName": "Jaybee",
                "lastName": "Ragudo",
                "year": 2019,
                "result": 0,
                "food": "",
                "title": "Five Time Competitor",
                "subtitle": "",
                "desc": "The 'Iron Stomach' competed in five straight events and was awarded the distinguised '5-time Fork' before announcing his retirement at GSV.",
                "division": "Professional",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/jaybee_spicy.jpg"
            },
            {
                "firstName": "Max",
                "lastName": "Mendola",
                "year": 2022,
                "result": 0,
                "food": "",
                "title": "Three Time Runner up",
                "subtitle": "",
                "desc": "So close he can taste it! The Portland native finished runner up in GSII, MegaBites, and GSIV. Will he ever return to the field for a shot at the gold?",
                "division": "Professional",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/maxgo.jpg"
            },
            {
                "firstName": "Stephen",
                "lastName": "Legge",
                "year": 2022,
                "result": 0,
                "food": "",
                "title": "The People's Champ",
                "subtitle": "",
                "desc": "The People's Champ has captivated fans since his first appearance in 2021 - can he finally capture the elusive Amateur title?",
                "division": "Amateur",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/legge2.jpg"
            },
            {
                "firstName": "Daniel",
                "lastName": "Herzog",
                "year": 2020,
                "result": 0,
                "food": "",
                "title": "MegaBites Champ",
                "subtitle": "",
                "desc": "Herzog's triumph over Connor Welty in the MegaBites Finale cemented his place in Gullet Stuffer lore, as he capped off the web series finale by eating 46 mini corndogs in 10 minutes.",
                "division": "Professional",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/Herzog.png"
            },
            {
                "firstName": "Dallas",
                "lastName": "",
                "year": 2022,
                "result": 0,
                "food": "",
                "title": "The Prodigy",
                "subtitle": "",
                "desc": "At just 8 years old, GSIV saw Dallas become the youngest athlete to ever take the stage, winning over the hearts of all in attendance. She made a surprise return in 2025 at age 11, thrilling thousands!",
                "division": "Amateur",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/dallas.jpg"
            },
            {
                "firstName": "Quinn",
                "lastName": "Madsen",
                "year": 2025,
                "result": 0,
                "food": "",
                "title": "Rad Dog Madsen",
                "subtitle": "",
                "desc": "Originally known as \"Mad Dog\", Quinn Madsen is a five time athlete that has inspired fans since his first appearance in 2019. He was honored with a Five Time Fork at GSVII alongside Stephen Legge.",
                "division": "Amateur",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/maddog.jpg"
            },
            {
                "firstName": "Conner",
                "lastName": "Deal",
                "year": 2025,
                "result": 0,
                "food": "",
                "title": "The Pickle",
                "subtitle": "",
                "desc": "In a shocking first impression, Conner took Grocery Outlet by storm at GSVII with a thunderous entrance and subsequent DQ, leaving fans wondering, what will he do next in his quest to become Seattle’s most iconic gherkin?",
                "division": "Amateur",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/thepickle.jpg"
            },
            {
                "firstName": "Parisa",
                "lastName": "Shahbaz",
                "year": 2025,
                "result": 0,
                "food": "",
                "title": "The Guzzler",
                "subtitle": "",
                "desc": "Goddess, Diva, Visionary… the list goes on. This Pickle Princess knows how to put on a show, whether it's starring in a promo video or taking the esteemed title of Top Fundraiser. Sit back and enjoy the show!",
                "division": "Amateur",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/notable_competitors/theguzz.jpg"
            }
        ],
        "top_fundraisers": [
            {
                "firstName": "Karisa",
                "lastName": "Gurtiza",
                "year": 2024,
                "result": "$917",
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/top_fundraisers/gurtiza_2024.jpg"
            },
            {
                "firstName": "The",
                "lastName": "Guzzler",
                "year": 2025,
                "result": "$1359",
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/top_fundraisers/TheGuzzler_2025.jpg"
            },
            {
                "firstName": "Mathias",
                "lastName": "Deeg",
                "year": 2026,
                "result": "$2119",
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/top_fundraisers/SweetCream_2026.JPG"
            }
        ],
        "iconic_moments": [
            {
                "firstName": "The",
                "lastName": "Sign",
                "year": 2021,
                "result": 0,
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "After a two year layoff, a return to competition featured the reveal of the iconic Neon Lettering, a product of @aftergloneon, order yours today!",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/iconic_moments/signreveal3.png"
            },
            {
                "firstName": "The",
                "lastName": "Eat Off",
                "year": 2019,
                "result": 0,
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "Tied at 68 Pizza Rolls, a rabid crowd demanded a tiebreaker between Jimmy Esteban and Max Mendola at the conclusion of GSII, the only instance of a tie in contest history!",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/iconic_moments/eatoff3.png"
            },
            {
                "firstName": "The",
                "lastName": "Billboard",
                "year": 2020,
                "result": 0,
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "A friendly discount and some generous donations led to the erection of the \"Zog Her Round the World\" sign, a celebration of Daniel Herzog's MegaBites title. The billboard was featured above food trucks in SE Portland, in the Spring of 2022.",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/iconic_moments/billboard3.png"
            },
            {
                "firstName": "The",
                "lastName": "Chug",
                "year": 2019,
                "result": 0,
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "Jaybee Ragudo shocked fans by shotgunning multiple cans of Code Red Mountain Dew in between bowls of soup during the GSIII Pro Division. Finishing at the bottom of the leaderboard, his performance left a lasting image for those in attendance.",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/iconic_moments/gametime1_crop.jpg"
            },
            {
                "firstName": "The",
                "lastName": "GOBM",
                "year": 2022,
                "result": 0,
                "food": "",
                "title": "",
                "subtitle": "",
                "desc": "Lacking a proper backyard venue for GSIV, in 2022 an agreement was struck to hold the event in the Grocery Outlet parking lot, where it has lived ever since.",
                "division": "",
                "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/hof_pics/iconic_moments/gobmcrop.png"
            }
        ]
    }
];